import Link from "next/link";
import {
  viewport,
  colors,
  font,
  lineHeight,
} from "../../../styles/cssinjs/helpers/variables.js";
export default function Footer({ data }) {
  const FooterLogo = () => {
    return (
      <Link href="/" prefetch={false} className="mr-auto company-logo">
        <img
          loading="lazy"
          src="https://assets.setmore.com/website/v2/images/logo/setmore-logo-white.svg"
          alt="Setmore logo in white color"
          width="156"
          height="24"
        />
      </Link>
    );
  };

  return (
    <>
      <footer className="is-minimal py-10 md:py-5">
        <div className="footer-wrap container fx">
          <FooterLogo />
          <p dangerouslySetInnerHTML={{ __html: data.community.label }} />
        </div>
        <style jsx>{`
          h1 {
            margin-top: -10px;
          }
          .mr-auto {
            margin-right: auto;
          }
          footer {
            background-color: ${colors.primitive.black[900]};
            text-align: left;
            padding-top: 82px;
          }
          footer p {
            font-size: inherit;
          }
          footer.is-minimal {
            color: ${colors.primitive.white.default};
          }
          footer.is-minimal p {
            font-size: ${font.size.md[1]};
          }
          @media (max-width: ${viewport.tablet.sm}) {
            footer.is-minimal .fx,
            footer.is-minimal a {
              display: block;
            }
            footer.is-minimal .footer-wrap > p {
              margin-top: 40px;
              max-width: 195px;
            }
          }
        `}</style>
      </footer>
    </>
  );
}
